export const FAQ_ITEMS = [
  {
    q: "ما هي حاسبة تكلفة العجلات؟",
    a: "أداة تساعدك في معرفة عدد CP اللازم لإكمال عجلة Lucky Draw في لعبة Call of Duty Mobile، مع اقتراح أفضل باقة أو مزيج باقات لتوفير المال.",
  },
  {
    q: "هل الأسعار الظاهرة رسمية؟",
    a: "لا، الأسعار تقديرية ومبنية على متوسط الأسعار في السوق. يرجى التحقق من السعر النهائي في متجر Rush Store قبل الشراء.",
  },
  {
    q: "ما الفرق بين نوع الحساب الخليجي والأفريقي والعالمي؟",
    a: "باقات CP في اللعبة تختلف أسعارها حسب منطقة الحساب. الحسابات الأفريقية عادة أرخص، والخليجية أغلى، بينما العالمي بسعر وسط.",
  },
  {
    q: "كيف تعمل خوارزمية اقتراح الباقات؟",
    a: "نقوم بتجربة كل تركيبات الباقات الممكنة لاختيار المزيج الذي يغطي CP المطلوب بأقل تكلفة ممكنة وأقل كمية CP زائدة.",
  },
  {
    q: "هل يمكنني إرسال النتيجة مباشرة للواتساب؟",
    a: "نعم، بعد ظهور النتيجة اضغط زر واتساب وسيتم إرسال رسالة جاهزة تحتوي تفاصيل حسابك وطلبك مباشرة إلى Rush Store.",
  },
  {
    q: "هل يمكنني شراء الباقة من نفس الموقع؟",
    a: "بعد الحساب اضغط زر الشراء ليتم توجيهك إلى صفحة المنتج في متجر Rush Store لإتمام الطلب بأمان عبر منصة سلة.",
  },
  {
    q: "ماذا لو كان عندي رصيد CP بالفعل؟",
    a: "أدخل رصيدك الحالي في الخانة المخصصة وسيتم خصمه تلقائياً من CP المطلوب، وستعرف بالضبط كم CP تحتاج إضافياً.",
  },
];
